import type { ColDef } from 'ag-grid-community';
import type { BulkManageRow } from '../types';
import { formatDate } from '../../manage-data/utils';
import { bulkManageSortFunction } from './bulkManageSortFunction';
import { isBulkManageInvestmentRow, isHistoricalBulkManageInvestmentRow, isBulkManageStrategyRow } from '../utils';
import { DateHeaderComponent } from './DateHeaderComponent';

const DATE_COLUMN_WIDTH = 140;
const REDUCED_DATE_COLUMN_WIDTH = 100;

export const startDateColDef = (
  isHistorical: boolean,
  holdingProxyFF: boolean,
): ColDef<BulkManageRow, number | undefined> => ({
  headerComponent: DateHeaderComponent,
  headerComponentParams: {
    title: holdingProxyFF ? 'Analysis Start' : 'Analysis Start Date',
    isHistorical,
  },
  valueGetter: ({ data }) => {
    if (isBulkManageInvestmentRow(data)) {
      return isHistoricalBulkManageInvestmentRow(data) ? data.historicalStartDate : data.startDate;
    }
    return undefined;
  },
  valueFormatter: ({ data, value }) => (isBulkManageStrategyRow(data) ? '' : (formatDate(value) ?? '')),
  width: holdingProxyFF ? REDUCED_DATE_COLUMN_WIDTH : DATE_COLUMN_WIDTH,
  comparator: bulkManageSortFunction(),
  aggFunc: 'max',
});

export const endDateColDef = (
  isHistorical: boolean,
  holdingProxyFF: boolean,
): ColDef<BulkManageRow, number | undefined> => ({
  headerComponent: DateHeaderComponent,
  headerComponentParams: {
    isHistorical,
    title: holdingProxyFF ? 'Analysis End' : 'Analysis End Date',
  },
  valueGetter: ({ data }) => {
    if (isBulkManageInvestmentRow(data)) {
      return isHistoricalBulkManageInvestmentRow(data) ? data.historicalEndDate : data.endDate;
    }
    return undefined;
  },
  valueFormatter: ({ data, value }) => (isBulkManageStrategyRow(data) ? '' : (formatDate(value) ?? '')),
  width: holdingProxyFF ? REDUCED_DATE_COLUMN_WIDTH : DATE_COLUMN_WIDTH,
  comparator: bulkManageSortFunction(),
  aggFunc: 'min',
});
